// services/cache/countryCache.ts

import { getRedisClient } from "../../client";
import { getKey } from "../../utils/redisKeys";

const prefix = "country";

export async function setCountry(id: string, value: any, ttlInSec?: number) {
  const client = getRedisClient();
  const key = getKey({ prefix, id });
  const stringified = JSON.stringify(value);

  if (ttlInSec) {
    await client.set(key, stringified, { EX: ttlInSec });
  } else {
    await client.set(key, stringified);
  }
}

export async function getCountry(id: string) {
  const client = getRedisClient();
  const key = getKey({ prefix, id });
  const data = await client.get(key);
  return data ? JSON.parse(data) : null;
}

export async function deleteCountry(id: string) {
  const client = getRedisClient();
  const key = getKey({ prefix, id });
  await client.del(key);
}

export async function getCountriesBulk(ids: string[]) {
  const client = getRedisClient();
  const keys = ids.map((id) => getKey({ prefix, id }));
  const results = await client.mGet(keys);
  return results.map((data) => (data ? JSON.parse(data) : null));
}